/**
 * Demo FAQs shown on the home page when the store
 * has not added any FAQ entries yet.
 */
export const faqsPlaceholder = [
    {
        id: 'placeholder-faq-1',
        question: {
            en: 'Do I need a reservation?',
            tr: 'Rezervasyon yapmam gerekir mi?',
            fa: 'آیا نیاز به رزرو دارم؟',
            ar: 'هل أحتاج إلى حجز؟',
            el: 'Χρειάζομαι κράτηση;',
            ru: 'Нужно ли бронировать столик?',
        },
        answer: {
            en: 'Walk-ins are welcome, but we recommend booking ahead for weekends and larger groups so we can prepare your table.',
            tr: 'Rezervasyonsuz da gelebilirsiniz; hafta sonları ve büyük gruplar için önceden yer ayırtmanızı öneririz.',
            fa: 'بدون رزرو هم پذیرایی می‌کنیم، اما برای آخر هفته‌ها و گروه‌های بزرگ پیشنهاد می‌کنیم از قبل رزرو کنید.',
            ar: 'يمكنك الحضور دون حجز، لكن ننصح بالحجز مسبقاً في عطلات نهاية الأسبوع وللمجموعات الكبيرة.',
            el: 'Δεχόμαστε και χωρίς κράτηση, αλλά προτείνουμε να κλείσετε τραπέζι για Σαββατοκύριακα και μεγάλες παρέες.',
            ru: 'Можно прийти без брони, но на выходные и для больших компаний лучше забронировать заранее.',
        },
    },
    {
        id: 'placeholder-faq-2',
        question: {
            en: 'How do online orders work?',
            tr: 'Online sipariş nasıl çalışır?',
            fa: 'سفارش آنلاین چگونه کار می‌کند؟',
            ar: 'كيف تعمل الطلبات عبر الإنترنت؟',
            el: 'Πώς λειτουργούν οι online παραγγελίες;',
            ru: 'Как работают онлайн-заказы?',
        },
        answer: {
            en: 'Browse the menu, add items to your cart, and checkout. You will get an order confirmation and can track progress from your account.',
            tr: 'Menüyü inceleyin, sepete ekleyin ve ödeme yapın. Sipariş onayı alırsınız ve hesabınızdan ilerlemeyi takip edebilirsiniz.',
            fa: 'منو را ببینید، به سبد اضافه کنید و پرداخت کنید. تأیید سفارش می‌گیرید و می‌توانید وضعیت را از حسابتان پیگیری کنید.',
            ar: 'تصفح القائمة وأضف العناصر إلى السلة ثم أكمل الدفع. ستصلك تأكيدية ويمكنك متابعة الطلب من حسابك.',
            el: 'Δείτε το μενού, προσθέστε στο καλάθι και ολοκληρώστε την παραγγελία. Θα λάβετε επιβεβαίωση και μπορείτε να παρακολουθείτε την πρόοδο από τον λογαριασμό σας.',
            ru: 'Выберите блюда в меню, добавьте в корзину и оформите заказ. Вы получите подтверждение и сможете отслеживать статус в аккаунте.',
        },
    },
    {
        id: 'placeholder-faq-3',
        question: {
            en: 'Do you offer vegetarian or allergen-friendly options?',
            tr: 'Vejetaryen veya alerjen dostu seçenekleriniz var mı?',
            fa: 'آیا گزینه‌های گیاهی یا مناسب آلرژی دارید؟',
            ar: 'هل لديكم خيارات نباتية أو مناسبة للحساسية؟',
            el: 'Έχετε χορτοφαγικές ή φιλικές προς αλλεργιογόνες επιλογές;',
            ru: 'Есть ли вегетарианские блюда или варианты без аллергенов?',
        },
        answer: {
            en: 'Yes. Many dishes can be adapted—check item details on the menu or ask our staff about ingredients and allergens.',
            tr: 'Evet. Birçok yemek uyarlanabilir; menüdeki ürün detaylarına bakın veya malzemeler ve alerjenler için personelimize sorun.',
            fa: 'بله. بسیاری از غذاها قابل تنظیم‌اند—جزئیات آیتم‌ها را در منو ببینید یا درباره مواد و آلرژن‌ها از کارکنان بپرسید.',
            ar: 'نعم. يمكن تعديل كثير من الأطباق—راجع تفاصيل الأصناف في القائمة أو اسأل فريقنا عن المكونات والمواد المسببة للحساسية.',
            el: 'Ναι. Πολλά πιάτα μπορούν να προσαρμοστούν—δείτε τις λεπτομέρειες στο μενού ή ρωτήστε το προσωπικό για συστατικά και αλλεργιογόνα.',
            ru: 'Да. Многие блюда можно адаптировать — смотрите описание в меню или спросите персонал об ингредиентах и аллергенах.',
        },
    },
    {
        id: 'placeholder-faq-4',
        question: {
            en: 'What are your opening hours?',
            tr: 'Çalışma saatleriniz nedir?',
            fa: 'ساعات کاری شما چیست؟',
            ar: 'ما هي ساعات العمل؟',
            el: 'Ποιο είναι το ωράριο λειτουργίας σας;',
            ru: 'Какой у вас график работы?',
        },
        answer: {
            en: 'Hours are listed on the Contact page and may change on holidays. Current times always reflect what is set in your store settings.',
            tr: 'Saatler İletişim sayfasında yer alır ve tatillerde değişebilir. Güncel saatler mağaza ayarlarınızdaki bilgilere göre gösterilir.',
            fa: 'ساعات در صفحه تماس آمده و ممکن است در تعطیلات تغییر کند. زمان‌های فعلی همان چیزی است که در تنظیمات فروشگاه ثبت شده.',
            ar: 'الساعات مذكورة في صفحة الاتصال وقد تتغير في العطل. الأوقات الحالية تعكس ما هو مضبوط في إعدادات المتجر.',
            el: 'Το ωράριο εμφανίζεται στη σελίδα Επικοινωνίας και μπορεί να αλλάξει σε αργίες. Οι τρέχουσες ώρες αντικατοπτρίζουν τις ρυθμίσεις του καταστήματος.',
            ru: 'Часы работы указаны на странице контактов и могут меняться в праздники. Актуальные часы соответствуют настройкам магазина.',
        },
    },
    {
        id: 'placeholder-faq-5',
        question: {
            en: 'Can I cancel or change my order?',
            tr: 'Siparişimi iptal veya değiştirebilir miyim?',
            fa: 'آیا می‌توانم سفارشم را لغو یا تغییر دهم؟',
            ar: 'هل يمكنني إلغاء أو تعديل طلبي؟',
            el: 'Μπορώ να ακυρώσω ή να αλλάξω την παραγγελία μου;',
            ru: 'Можно ли отменить или изменить заказ?',
        },
        answer: {
            en: 'If your order is still being prepared, contact us right away with your order number and we will help as quickly as we can.',
            tr: 'Siparişiniz hâlâ hazırlanıyorsa sipariş numaranızla hemen bize ulaşın; mümkün olan en kısa sürede yardımcı oluruz.',
            fa: 'اگر سفارش هنوز در حال آماده‌سازی است، با شماره سفارش فوراً با ما تماس بگیرید تا در اسرع وقت کمک کنیم.',
            ar: 'إذا كان طلبك لا يزال قيد التحضير، تواصل معنا فوراً برقم الطلب وسنساعدك بأسرع ما يمكن.',
            el: 'Αν η παραγγελία σας ακόμα προετοιμάζεται, επικοινωνήστε αμέσως μαζί μας με τον αριθμό παραγγελίας και θα βοηθήσουμε το συντομότερο.',
            ru: 'Если заказ ещё готовится, сразу свяжитесь с нами и укажите номер заказа — мы поможем как можно быстрее.',
        },
    },
];
